<template>
    <div v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewDashboard)" id="dashboard-main">
        <div v-if="loading" class="col-12 mt-5 mb-5" v-loading="true"></div>
        <div class="row" v-else>
            <div class="col-12">
                <!-- <el-select
                    v-model="paymentStatus"
                    @change="getData">
                        <el-option :value="null" label="All"/>
                        <el-option value="fully-paid" label="Fully Paid"/>
                        <el-option value="not-paid" label="Not Paid"/>
                        <el-option value="some-payment-made" label="Some Payment Made"/>
                </el-select> -->

                <el-select multiple v-model="filter" placeholder="Status" @change="filterData">
                    <el-option value="all" label="All"/>
                    <el-option value="confirmed">Confirmed</el-option>
                    <el-option value="pending">Pending</el-option>
                    <el-option value="rejected">Rejected</el-option>
                    <el-option value="deleted">Deleted</el-option>
                </el-select>
            </div>
            <div class="col-md-3">
                <card class="card-stats" style="min-height: 255px;">
                    <div class="statistics statistics-horizontal mb-2" style="border-bottom: 1px solid #E5E5E5;">
                        <div class="info info-horizontal">
                            <h2>Registration Info</h2>
                            <div class="d-flex" style="justify-content: center;">
                                <fa :icon="['fas', 'users']" size="3x"/>
                            </div>
                            <div class="d-flex p-0 m-0" style="flex-wrap: wrap; justify-content: center;">
                                <div class="left" style="text-align: center;">
                                    <h3 class="info-title">{{ getTotalRegistrationCount }}</h3>
                                    <p class="stats-title">Registrations</p>
                                </div>
                                <div class="right" style="text-align: center;">
                                    <h3 class="info-title">{{ getTotalAttendees.length }}</h3>
                                    <p class="stats-title">Registrants</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="stats">
                        <fa :icon="['far', 'arrow-alt-circle-up']"/> {{ getTotalAttendees.length - getCheckedIn }} remaining<br>
                        <fa :icon="['fas', 'plus']"/> {{ getCheckedIn }} Checked In
                    </div>
                </card>
            </div>
            <div class="col-md-3" v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].viewTransactionSummary))">

                <card class="card-stats" style="min-height: 255px;">
                    <div class="statistics statistics-horizontal">
                        <div class="info info-horizontal">
                            <h2>Transaction Summary</h2>
                            <div class="d-flex" style="justify-content: center;">
                                <fa :icon="['fas', 'ticket-alt']" size="3x"/>
                            </div>

                            <div class="d-flex mt-2" style="text-align: center; justify-content: center; align-items: center; gap:10px">
                                <h3 class="info-title p-0 m-0">$ {{ getTotals }} </h3>
                                <p class="stats-title m-0 p-0" style="font-size: 16px; height: auto;">Total</p>
                            </div>

                            <div class="d-flex p-0 m-0" style="flex-wrap: wrap; justify-content: center; gap:20px">
                                <div class="left" style="text-align: center;">
                                    <h3 class="info-title">$ {{ getPaids }}</h3>
                                    <p class="stats-title">Paid</p>
                                </div>
                                <div class="right" style="text-align: center;">
                                    <h3 class="info-title">$ {{ getDues }}</h3>
                                    <p class="stats-title">Due</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
                
            </div>
            <div class="col-md-3" v-if="this.event.enableUnsatisfiedMinimumCount">
                <stats-card
                    style="min-height: 255px;"
                    type="warning"
                    header="Unsatisfied Minimum Count"
                    :title="getUnsatisfiedMinimumCount">
                </stats-card>
            </div>
            <div
                v-for="activity in stats.activities"
                :key="`activity-stat-${activity._id}`"
                class="col-md-3">
                    <stats-card
                        style="min-height: 255px;"
                        type="danger"
                        :title="`${getAttendees[activity._id] ? getAttendees[activity._id].length : 0}`"
                        :header="activity.name"
                        subTitle="Total">
                            <template slot="icon">
                                <fa :icon="['fas', 'barcode']" size="3x"/>
                            </template>
                            <div slot="footer">
                                <fa :icon="['far', 'arrow-alt-circle-up']"/> {{ getAttendees[activity._id] && getCheckinedInAttendees[activity._id] ? getAttendees[activity._id].length - getCheckinedInAttendees[activity._id].length : 0 }} Remaining<br>
                                <fa :icon="['fas', 'plus']"/> {{ getCheckinedInAttendees[activity._id] ? getCheckinedInAttendees[activity._id].length : 0 }} Checked In
                            </div>
                    </stats-card>
            </div>
        </div>
    </div>
</template>

<script>
import StatsCard from '@/components/now-ui/Cards/StatsCard'
import { mapState } from 'vuex'
import http from '../http.js'

export default {
    components: {
        StatsCard
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ]),
        getTotals(){
            let totals = 0
            Object.keys(this.stats.transactions.totals).forEach(key =>{
                if(this.filter.includes('all')){
                    totals = this.stats.transactions.totals['all']
                }
                else if(this.filter.includes(key)){
                    totals += this.stats.transactions.totals[key]
                }
            })
            return String(totals)
        },
        getPaids(){
            let paids = 0
            Object.keys(this.stats.transactions.paids).forEach(key =>{
                if(this.filter.includes('all')){
                    paids = this.stats.transactions.paids['all']
                }
                else if(this.filter.includes(key)){
                    paids += this.stats.transactions.paids[key]
                }
            })
            return String(paids);
        },
        getDues(){
            let dues = 0
            Object.keys(this.stats.transactions.dues).forEach(key =>{
                if(this.filter.includes('all')){
                    dues = this.stats.transactions.dues['all']
                }
                else if(this.filter.includes(key)){
                    dues += this.stats.transactions.dues[key]
                }
            })
            return String(dues);
        },
        getUnsatisfiedMinimumCount(){
            let count = 0;
            Object.keys(this.stats.unsatisfiedMinimumCountWithStatus).forEach((key, value) =>{
                if(this.filter.includes('all')){
                    count += parseInt(value)
                }
                else if(this.filter.includes(key)){
                    count += parseInt(value)
                }
            })
            return String(count);
        },
        getAttendees() {
            let obj = {}
            this.stats.activities.forEach(activity => {
                obj[activity._id] = []
                activity.registeredAttendees.forEach(attendee => {
                    if(this.filter.includes('all')) {
                        obj[activity._id].push(attendee)
                    }
                    else if(this.filter.includes(attendee.status)){
                        obj[activity._id].push(attendee)
                    }  
                })
            })
            return obj
        },
        getCheckinedInAttendees() {
            let obj = {}
            this.stats.activities.forEach(activity => {
                obj[activity._id] = []
                activity.checkedInAttendees.forEach(attendee => {
                    if(this.filter.includes('all')) {
                        obj[activity._id].push(attendee)
                    }
                    else if(this.filter.includes(attendee.status)){
                        obj[activity._id].push(attendee)
                    }  
                })
            })
            return obj
        },
        getTotalAttendees() {
            const users = this.stats.users.total.filter(user => {
                if(this.filter.includes('all')) return true;
                return this.filter.includes(user.status);
            })
            return users;
        },
        getCheckedIn(){
            const users = this.stats.users.checkedIn.filter(user => {
                if(this.filter.includes('all')) return true;
                return this.filter.includes(user.status);
            })
            return users.length;
        },
        getTotalRegistrationCount(){
            let confirmationNumbers = new Set([])
            this.getTotalAttendees.forEach(attendee => {
                confirmationNumbers.add(attendee.confirmationNumber)
            })
            return confirmationNumbers.size
        }
    },
    data () {
        return {
            loading: true,
            filter: ["confirmed","pending"],
            stats: {
                users: {
                    checkedIn: [],
                    total:[]
                },
                sales: {
                    paid: 0,
                    pending: 0
                },
                activities: []
            }
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData: async function () {
            this.loading = true
            try {
                const response = await http.get(`/api/stats/${this.$route.params.eventId}?${this.event.enableUnsatisfiedMinimumCount ? 'unsatisfiedMinimumCount=true' : ''}`, { params: { paymentStatus: this.paymentStatus } })
                this.stats = response.data.stats
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error getting dashboard data')
            }
            this.loading = false
        },
        filterData(val){
            console.log(val);
        }
    }
}
</script>

<style lang="sass">
#dashboard-main
    .card-stats .statistics .stats-title
        height: 32px
</style>
